import Stripe from "stripe";
import { create } from "zustand";
import { WLStripeWPlanSubscription } from "../../../Common/models/subscriptions";

export const STRIPE_PAYMENT_METHODS_QUERY_KEYS = {
  existingCustomer: "GET_STRIPE_EXISTING_CUSTOMER_COMMON",
  existingSubscription: "GET_STRIPE_EXISTING_SUBSCRIPTION_COMMON",
  paymentMethods: "GET_STRIPE_PAYMENT_METHODS_COMMON",
} satisfies {
  [key: string]: string;
};

interface StripePaymentMethodStore {
  paymentMethods: undefined | Stripe.PaymentMethod[] | null;
  setPaymentMethods: (state: Stripe.PaymentMethod[]) => void;

  selectedPaymentMethod: undefined | Stripe.PaymentMethod | null;
  setSelectedPaymentMethod: (state: Stripe.PaymentMethod | null) => void;

  stripeShowAddCard: boolean;
  setStripeShowAddCard: (state: boolean) => void;

  // only for subscription
  defaultPaymentMethodId: undefined | null | string;
  setDefaultPaymentMethod: (state: string) => void;

  existingSubscription: undefined | WLStripeWPlanSubscription | null;
  setExistingSubscription: (state: WLStripeWPlanSubscription | null) => void;

  existingSubscriptionLoading: boolean;
  setExistingSubscriptionLoading: (state: boolean) => void;

  existingSubscriptionLoadFailed: boolean;
  setExistingSubscriptionLoadFailed: (state: boolean) => void;

  // just used to check for default payment
  existingCustomer: undefined | Stripe.Customer | null;
  setExistingCustomer: (state: Stripe.Customer | null) => void;

  useOtherPaymentMethod: null | (() => void);
  setUseOtherPaymentMethodFunc: (func: () => void) => void;

  error: string;
  setError: (state: string) => void;

  reset: (state?: { hasOtherPaymentMethod?: boolean }) => void;
}

const useStripePaymentMethodStore = create<StripePaymentMethodStore>(
  (set, get) => ({
    paymentMethods: undefined,
    setPaymentMethods: (paymentMethods) => set({ paymentMethods }),

    selectedPaymentMethod: undefined,
    setSelectedPaymentMethod: (selectedPaymentMethod) =>
      set({ selectedPaymentMethod }),

    stripeShowAddCard: false,
    setStripeShowAddCard: (stripeShowAddCard) => set({ stripeShowAddCard }),

    defaultPaymentMethodId: undefined,
    setDefaultPaymentMethod: (defaultPaymentMethodId) =>
      set({ defaultPaymentMethodId }),

    existingSubscription: undefined,
    setExistingSubscription: (existingSubscription) =>
      set({ existingSubscription }),

    existingSubscriptionLoading: true,
    setExistingSubscriptionLoading: (existingSubscriptionLoading) =>
      set({ existingSubscriptionLoading }),

    existingSubscriptionLoadFailed: false,
    setExistingSubscriptionLoadFailed: (existingSubscriptionLoadFailed) =>
      set({ existingSubscriptionLoadFailed }),

    existingCustomer: undefined,
    setExistingCustomer: (existingCustomer) => set({ existingCustomer }),

    useOtherPaymentMethod: null,
    setUseOtherPaymentMethodFunc: (useOtherPaymentMethod) =>
      set({ useOtherPaymentMethod }),

    error: "",
    setError: (error) => set({ error }),

    reset: (state) =>
      set({
        paymentMethods: undefined,
        selectedPaymentMethod: undefined,
        stripeShowAddCard: false,
        defaultPaymentMethodId: undefined,
        existingSubscription: undefined,
        existingSubscriptionLoading: true,
        existingSubscriptionLoadFailed: false,
        existingCustomer: undefined,
        useOtherPaymentMethod: state?.hasOtherPaymentMethod
          ? null
          : get().useOtherPaymentMethod,
        error: "",
      }),
  })
);

export default useStripePaymentMethodStore;
